import { GenUtil } from "../../base/cutil/GenUtil";
import { StoreBase } from "../../base/cutil/StoreBase";
export var GroupCOEStatus;
(function (GroupCOEStatus) {
    GroupCOEStatus[GroupCOEStatus["Collapse"] = 0] = "Collapse";
    GroupCOEStatus[GroupCOEStatus["Expand"] = 1] = "Expand";
})(GroupCOEStatus || (GroupCOEStatus = {}));
class GroupCOEData {
    constructor() {
        this.groupId = "";
    }
}
export class HomeStoreState {
    constructor() {
        this.isClickAddNewProject = false;
        this.groupCOEData = [];
    }
    copyWith(params) {
        return GenUtil.copyWith(new HomeStoreState(), this, params);
    }
}
export class HomeStore extends StoreBase {
    constructor() {
        super(() => new HomeStoreState());
    }
    setState(param) {
        let newState = this.state.copyWith(param);
        this.emit(newState);
    }
    setIsClickAddNewProject(isClickAddNewProject) {
        this.setState({ isClickAddNewProject });
    }
    setGroupCOEData(groupCOEData) {
        let newGroupCOEData = this.state.groupCOEData;
        const existIdx = this.state.groupCOEData.findIndex((x) => x.groupId === groupCOEData.groupId);
        const mergedGroupCOEData = Object.assign({}, this.state.groupCOEData[existIdx] || {
            groupId: "",
            groupCOEStatus: 1,
            collapseChildNodes: [],
        }, groupCOEData);
        if (existIdx > -1) {
            newGroupCOEData.splice(existIdx, 1, mergedGroupCOEData);
        }
        else {
            newGroupCOEData.push(mergedGroupCOEData);
        }
        this.setState({ groupCOEData: newGroupCOEData });
    }
    cleanGroupCOEData() {
        this.setState({ groupCOEData: [] });
    }
}
